var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDrag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_433_83431"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_433_83431)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5,2C5,2,7,2,7,2C7,2,7,4,7,4C7,4,5,4,5,4C5,4,5,2,5,2C5,2,5,2,5,2ZM9,2C9,2,11,2,11,2C11,2,11,4,11,4C11,4,9,4,9,4C9,4,9,2,9,2C9,2,9,2,9,2ZM5,7C5,7,7,7,7,7C7,7,7,9,7,9C7,9,5,9,5,9C5,9,5,7,5,7C5,7,5,7,5,7ZM9,7C9,7,11,7,11,7C11,7,11,9,11,9C11,9,9,9,9,9C9,9,9,7,9,7C9,7,9,7,9,7ZM5,12C5,12,7,12,7,12C7,12,7,14,7,14C7,14,5,14,5,14C5,14,5,12,5,12C5,12,5,12,5,12ZM9,12C9,12,11,12,11,12C11,12,11,14,11,14C11,14,9,14,9,14C9,14,9,12,9,12C9,12,9,12,9,12Z",
    fillRule: "evenodd",
    fill: "currentColor",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrag);
export default __webpack_public_path__ + "static/media/icon_drag.1e2140bcc7df62eb6c181f7e546a196d.svg";
export { ForwardRef as ReactComponent };